/**
 * Retention state of a run's replay bundle, shared between the trace service that
 * retags it server-side and the admin agent-runs frontend that renders/filters by
 * it — so neither re-declares the `'transient' | 'promoted'` union as raw literals.
 *
 * - `Transient`: kept only until the transient TTL expires.
 * - `Promoted`: pinned past the TTL (manually, from the back-office).
 */
export enum ReplayLifecycle {
  Transient = 'transient',
  Promoted = 'promoted',
}
